import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as brandIcons from '@fortawesome/free-brands-svg-icons'
import * as solidIcons from '@fortawesome/free-solid-svg-icons'
import * as regularIcons from '@fortawesome/free-regular-svg-icons'

import styles from './icon.module.scss'

export type IconColor = 'orange' | 'blue' | 'grey' | 'green' | 'purple'
export type IconSize = 'small' | 'large' | 'huge' | 'big' | 'massive'
export type LegacyIcons = keyof typeof Icons

const Icons: Record<string, any> = {
  add: solidIcons.faAdd,
  'address book outline': regularIcons.faAddressBook,
  'address book': regularIcons.faAddressBook,
  'address card outline': regularIcons.faAddressCard,
  adjust: solidIcons.faAdjust,
  'align center': solidIcons.faAlignCenter,
  'align justify': solidIcons.faAlignJustify,
  'align left': solidIcons.faAlignLeft,
  'align right': solidIcons.faAlignRight,
  'angle double down': solidIcons.faAnglesDown,
  'angle double up': solidIcons.faAnglesUp,
  'angle down': solidIcons.faAngleDown,
  archive: solidIcons.faBoxArchive,
  'arrow alternate circle down outline': regularIcons.faArrowAltCircleDown,
  'arrow alternate circle left outline': regularIcons.faArrowAltCircleLeft,
  'arrow alternate circle right outline': regularIcons.faArrowAltCircleRight,
  'arrow alternate circle right': regularIcons.faArrowAltCircleRight,
  'arrow alternate circle up outline': regularIcons.faArrowAltCircleUp,
  'arrow circle down': regularIcons.faArrowAltCircleDown,
  'arrow circle left': regularIcons.faArrowAltCircleLeft,
  'arrow circle right': regularIcons.faArrowAltCircleRight,
  'arrow circle up': regularIcons.faArrowAltCircleUp,
  'arrow down': solidIcons.faArrowDown,
  'arrow left': solidIcons.faArrowLeft,
  'arrow right': solidIcons.faArrowRight,
  'arrow up': solidIcons.faArrowUp,
  'arrows alternate vertical': solidIcons.faUpRightAndDownLeftFromCenter,
  backward: solidIcons.faBackward,
  'balance scale': solidIcons.faBalanceScale,
  ban: solidIcons.faBan,
  bars: solidIcons.faBars,
  'bell outline': regularIcons.faBell,
  bluesky: brandIcons.faBluesky,
  bold: solidIcons.faBold,
  bolt: solidIcons.faBolt,
  book: solidIcons.faBook,
  'bookmark outline': regularIcons.faBookmark,
  bookmark: solidIcons.faBookmark,
  boxes: solidIcons.faBoxes,
  bug: solidIcons.faBug,
  'calendar alternate outline': regularIcons.faCalendar,
  calendar: regularIcons.faCalendar,
  cancel: solidIcons.faXmark,
  'caret down': solidIcons.faCaretDown,
  'caret left': solidIcons.faCaretLeft,
  'caret right': solidIcons.faCaretRight,
  'caret up': solidIcons.faCaretUp,
  cart: solidIcons.faCartShopping,
  chain: solidIcons.faChain,
  'chart bar': solidIcons.faBarChart,
  'chart line': solidIcons.faLineChart,
  chat: solidIcons.faCommentDots,
  'check circle outline': regularIcons.faCheckCircle,
  'check circle': regularIcons.faCircleCheck,
  'check square': regularIcons.faCheckSquare,
  check: solidIcons.faCheck,
  checkmark: solidIcons.faCheck,
  chess: solidIcons.faChess,
  'chess king': solidIcons.faChessKing,
  'chess queen': solidIcons.faChessQueen,
  'chevron circle down': solidIcons.faChevronCircleDown,
  'chevron circle left': solidIcons.faChevronCircleLeft,
  'chevron circle right': solidIcons.faChevronCircleRight,
  'chevron circle up': solidIcons.faChevronCircleUp,
  'chevron down': solidIcons.faChevronDown,
  'chevron left': solidIcons.faChevronLeft,
  'chevron right': solidIcons.faChevronRight,
  'chevron up': solidIcons.faChevronUp,
  'circle check': regularIcons.faCircleCheck,
  'circle outline': regularIcons.faCircle,
  'circle-half-stroke': solidIcons.faCircleHalfStroke,
  'circle-plus': solidIcons.faCirclePlus,
  circle: solidIcons.faCircle,
  clock: regularIcons.faClock,
  'clone outline': regularIcons.faClone,
  clone: regularIcons.faClone,
  close: solidIcons.faXmark,
  'cloud download': solidIcons.faCloudDownload,
  'code branch': solidIcons.faCodeBranch,
  'code-compare': solidIcons.faCodeCompare,
  code: solidIcons.faCode,
  cog: solidIcons.faCog,
  columns: solidIcons.faColumns,
  'comment outline': regularIcons.faComment,
  comment: regularIcons.faComment,
  'comments outline': regularIcons.faComment,
  'copy outline': regularIcons.faCopy,
  copy: regularIcons.faCopy,
  crown: solidIcons.faCrown,
  cube: solidIcons.faCube,
  cubes: solidIcons.faCubes,
  dice: solidIcons.faDice,
  discord: brandIcons.faDiscord,
  'dollar sign': solidIcons.faDollarSign,
  dolly: solidIcons.faDolly,
  download: solidIcons.faDownload,
  dropdown: solidIcons.faCaretDown,
  'edit outline': regularIcons.faPenToSquare,
  edit: regularIcons.faPenToSquare,
  'ellipsis horizontal': solidIcons.faEllipsis,
  'ellipsis vertical': solidIcons.faEllipsisVertical,
  exchange: solidIcons.faArrowRightArrowLeft,
  'exclamation triangle': solidIcons.faExclamationTriangle,
  'external alternate': solidIcons.faExternalLinkAlt,
  external: solidIcons.faExternalLink,
  'eye dropper': solidIcons.faEyeDropper,
  'eye slash': regularIcons.faEyeSlash,
  eye: regularIcons.faEye,
  facebook: brandIcons.faFacebook,
  'fast forward': solidIcons.faFastForward,
  'file alternate outline': regularIcons.faFileLines,
  'file image outline': regularIcons.faFileImage,
  'file outline': regularIcons.faFile,
  file: regularIcons.faFile,
  filter: solidIcons.faFilter,
  fire: solidIcons.faFire,
  'flag checkered': solidIcons.faFlagCheckered,
  'flag outline': regularIcons.faFlag,
  flask: solidIcons.faFlask,
  'folder open outline': regularIcons.faFolderOpen,
  'folder open': regularIcons.faFolderOpen,
  'folder outline': regularIcons.faFolderOpen,
  folder: regularIcons.faFolder,
  font: solidIcons.faFont,
  gavel: solidIcons.faGavel,
  'gem outline': regularIcons.faGem,
  gem: solidIcons.faGem,
  gift: solidIcons.faGift,
  globe: solidIcons.faGlobe,
  'grid layout': solidIcons.faGrip,
  group: solidIcons.faUsers,
  'hand point up outline': regularIcons.faHandPointUp,
  'hand pointer outline': regularIcons.faHandPointer,
  'heart outline': regularIcons.faHeart,
  heart: solidIcons.faHeart,
  history: solidIcons.faHistory,
  home: solidIcons.faHome,
  'image outline': regularIcons.faImage,
  image: regularIcons.faImage,
  'info circle': solidIcons.faInfoCircle,
  info: solidIcons.faInfo,
  italic: solidIcons.faItalic,
  lab: solidIcons.faFlask,
  'level down': solidIcons.faTurnDown,
  'level up alternate': solidIcons.faTurnUp,
  'level up': solidIcons.faTurnUp,
  'line graph': solidIcons.faChartLine,
  'list ol': solidIcons.faListOl,
  list: regularIcons.faListAlt,
  'lock open': solidIcons.faLockOpen,
  lock: solidIcons.faLock,
  'log out': solidIcons.faArrowRightFromBracket,
  magic: solidIcons.faWandMagicSparkles,
  mail: regularIcons.faEnvelopeOpen,
  'map marker alternate': solidIcons.faLocationDot,
  'minus circle': solidIcons.faCircleMinus,
  minus: solidIcons.faMinus,
  'money bill alternate outline': regularIcons.faMoneyBill1,
  money: regularIcons.faMoneyBill1,
  moon: regularIcons.faMoon,
  'newspaper outline': regularIcons.faNewspaper,
  newspaper: regularIcons.faNewspaper,
  'numbered list': solidIcons.faListOl,
  'paint brush': solidIcons.faPaintBrush,
  paste: regularIcons.faPaste,
  patreon: brandIcons.faPatreon,
  paw: solidIcons.faPaw,
  'pencil alternate': solidIcons.faPencil,
  pencil: solidIcons.faPencil,
  'pie chart': solidIcons.faPieChart,
  'pie graph': solidIcons.faPieChart,
  pin: solidIcons.faThumbTack,
  'play-circle': regularIcons.faPlayCircle,
  play: solidIcons.faPlay,
  plus: solidIcons.faPlus,
  privacy: solidIcons.faKey,
  qrcode: solidIcons.faQrcode,
  'question circle outline': regularIcons.faQuestionCircle,
  'question circle': regularIcons.faQuestionCircle,
  question: solidIcons.faQuestion,
  'quote left': solidIcons.faQuoteLeft,
  'quote right': solidIcons.faQuoteRight,
  recycle: solidIcons.faRecycle,
  redo: solidIcons.faRedo,
  refresh: solidIcons.faRefresh,
  'remove bookmark': regularIcons.faBookmark,
  'remove circle': regularIcons.faCircleXmark,
  remove: solidIcons.faClose,
  reply: solidIcons.faReply,
  'save outline': regularIcons.faSave,
  save: regularIcons.faSave,
  search: solidIcons.faSearch,
  settings: solidIcons.faCogs,
  'share alternate': solidIcons.faShareNodes,
  share: solidIcons.faShare,
  'shield alternate': solidIcons.faShieldHalved,
  'shopping cart': solidIcons.faShoppingCart,
  shuffle: solidIcons.faShuffle,
  'sign in': solidIcons.faSignIn,
  'sign out': solidIcons.faSignOut,
  sitemap: solidIcons.faSitemap,
  skull: solidIcons.faSkull,
  slash: solidIcons.faSlash,
  'sliders horizontal': solidIcons.faSliders,
  'sort alphabet ascending': solidIcons.faSortAlphaAsc,
  'sort alphabet descending': solidIcons.faSortAlphaDesc,
  'sort amount down': solidIcons.faSortAmountDesc,
  'sort amount up': solidIcons.faSortAmountAsc,
  'sort content ascending': solidIcons.faSortAmountAsc,
  'sort content descending': solidIcons.faSortAmountDesc,
  'sort numeric down': solidIcons.faSortNumericDesc,
  'sort numeric up': solidIcons.faSortNumericAsc,
  'square outline': regularIcons.faSquare,
  square: regularIcons.faSquare,
  'star outline': regularIcons.faStar,
  star: solidIcons.faStar,
  'sticky note': regularIcons.faStickyNote,
  strikethrough: solidIcons.faStrikethrough,
  sun: regularIcons.faSun,
  superscript: solidIcons.faSuperscript,
  tag: solidIcons.faTag,
  tags: solidIcons.faTags,
  th: solidIcons.faTh,
  'thumbs down outline': regularIcons.faThumbsDown,
  'thumbs down': regularIcons.faThumbsDown,
  'thumbs up outline': regularIcons.faThumbsUp,
  'thumbs up': regularIcons.faThumbsUp,
  'times circle outline': regularIcons.faCircleXmark,
  'times circle': regularIcons.faCircleXmark,
  'trash alternate outline': solidIcons.faTrash,
  'trash alternate': regularIcons.faTrashCan,
  trash: solidIcons.faTrash,
  tree: solidIcons.faTree,
  'triangle down': solidIcons.faCaretDown, // Dropdown indicator
  trophy: solidIcons.faTrophy,
  twitch: brandIcons.faTwitch,
  underline: solidIcons.faUnderline,
  'undo alternate': solidIcons.faUndo,
  undo: solidIcons.faUndo,
  unlock: solidIcons.faUnlock,
  upload: solidIcons.faUpload,
  'user circle outline': regularIcons.faUserCircle,
  'user circle': regularIcons.faUserCircle,
  'user plus': solidIcons.faUserPlus,
  user: regularIcons.faUser,
  users: solidIcons.faUsers,
  'warning sign': solidIcons.faTriangleExclamation,
  weight: solidIcons.faWeight,
  'window maximize outline': regularIcons.faWindowMaximize,
  'window minimize': regularIcons.faWindowMinimize,
  wizard: solidIcons.faHatWizard,
  wrench: solidIcons.faWrench,
  'write square': regularIcons.faPenToSquare,
  youtube: brandIcons.faYoutube,
}

type Props = {
  name?: LegacyIcons
  color?: IconColor
  className?: string
  style?: React.CSSProperties
  title?: string
  size?: IconSize
}

const COLOR_CLASS_NAMES: Record<IconColor, string> = {
  orange: styles.orange,
  blue: styles.blue,
  grey: styles.grey,
  green: styles.green,
  purple: styles.purple,
}

const SIZE_CLASS_NAMES: Record<IconSize, string> = {
  small: styles.small,
  large: styles.large,
  huge: styles.large,
  big: styles.large,
  massive: styles.xLarge,
}

const Icon = ({ name, color, size, className = '', title, style }: Props) => {
  const icon = name ? Icons[name] : undefined
  const colorClassName = color ? COLOR_CLASS_NAMES[color] : ''
  const sizeClassName = size ? SIZE_CLASS_NAMES[size] : ''

  // Custom Icon
  if (!icon)
    return (
      <i
        aria-hidden={true}
        className={`icon ${className} ${colorClassName} ${sizeClassName}`}
        style={style}
        title={title}
      />
    )

  return (
    <FontAwesomeIcon
      icon={icon}
      title={title}
      style={style}
      className={`${styles.icon} ${className} ${colorClassName} ${sizeClassName}`}
    />
  )
}

export default Icon
